import { useI18n } from '@/i18n';

const labels = {ko:'한국어',en:'English',ja:'日本語',zh:'中文',es:'Español',pt:'Português'};
export const PublicLanguageSelect = ({id, className = ''}) => {
  const {lang,setLang,tx} = useI18n();
  return <select data-testid={id} aria-label={tx('Language')} value={lang} onChange={e=>setLang(e.target.value)} className={`max-w-full rounded border border-current/25 bg-transparent px-2 py-1 text-sm ${className}`}>
    {Object.entries(labels).map(([value,label])=><option data-testid={`${id}-option-${value}`} className="bg-white text-black" value={value} key={value}>{label}</option>)}
  </select>;
};